/**
 * VoyageSidebar.js
 *
 * Sidebar for the Voyage tab.
 * Matches MaintenanceSidebar and DrillsSidebar pattern exactly.
 */

import React from 'react';
import { Plus, History, Ship, Settings } from 'lucide-react';
import VoyageSummaryCard from './VoyageSummaryCard';

const VoyageSidebar = ({
  stats,
  activeVoyage,
  onStartVoyage,
  onViewHistory,
  onSettings
}) => {
  return (
    <div className="space-y-6">
      {/* Summary Card */}
      <VoyageSummaryCard stats={stats} activeVoyage={activeVoyage} />

      {/* Quick Actions Card */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-slate-700 px-5 py-3">
          <h3 className="text-base font-semibold text-white flex items-center gap-2">
            <Ship className="h-5 w-5 text-white" />
            Quick Actions
          </h3>
        </div>
        <div className="p-6 space-y-2">
          {!activeVoyage && (
            <button
              onClick={onStartVoyage}
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-cyan-600 rounded-md hover:bg-cyan-700"
            >
              <Plus className="h-4 w-4" />
              Start Voyage
            </button>
          )}
          <button
            onClick={onViewHistory}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            <History className="h-4 w-4" />
            Voyage History
          </button>
          <button
            onClick={onSettings}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            <Settings className="h-4 w-4" />
            Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default VoyageSidebar;
